(() => {
  if (window.detailshopProductCardHoverImages) return;
  window.detailshopProductCardHoverImages = true;

  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mediaSelector = '.product-card__media.has-secondary-image';

  function parseCardVariants(card) {
    if (card.variantData) return card.variantData;

    try {
      card.variantData = JSON.parse(card.querySelector('[data-card-variants]')?.textContent || '[]');
    } catch (_error) {
      card.variantData = [];
    }

    return card.variantData;
  }

  function selectCardVariant(button, optionSelector) {
    const card = button.closest('[data-variant-product-card]');
    if (!card) return;

    card.querySelectorAll(optionSelector).forEach((option) => {
      option.setAttribute('aria-pressed', String(option === button));
    });

    const selectedContent = card.querySelector('[data-card-content-option][aria-pressed="true"]')?.dataset.cardContentOption;
    const selectedColor = card.querySelector('[data-card-color-option][aria-pressed="true"]')?.dataset.cardColorOption;
    const matchingVariants = parseCardVariants(card).filter((variant) => (
      (!selectedContent || variant.contentValue === selectedContent)
      && (!selectedColor || variant.colorValue === selectedColor)
    ));
    const variant = matchingVariants.find((item) => item.available) || matchingVariants[0];
    if (!variant) return;

    const price = card.querySelector('[data-card-price]');
    const pricePrefix = card.querySelector('[data-card-price-prefix]');
    const comparePrice = card.querySelector('[data-card-compare-price]');
    const discount = card.querySelector('[data-card-discount]');
    const stock = card.querySelector('[data-card-stock]');
    const variantLink = card.querySelector('[data-card-variant-link]');

    if (price) price.textContent = variant.price;
    if (pricePrefix) pricePrefix.hidden = true;
    if (comparePrice) {
      comparePrice.textContent = variant.comparePrice || '';
      comparePrice.hidden = !variant.comparePrice;
    }
    if (discount) {
      discount.textContent = variant.discountPercentage > 0 ? `-${variant.discountPercentage}%` : '';
      discount.hidden = variant.discountPercentage <= 0;
    }
    if (stock) {
      stock.textContent = variant.available ? stock.dataset.inStockLabel : stock.dataset.soldOutLabel;
      stock.classList.toggle('is-sold-out', !variant.available);
    }

    const variantUrl = `${variantLink?.dataset.cardProductUrl || card.querySelector('[data-card-product-link]')?.pathname || ''}?variant=${variant.id}`;
    card.querySelectorAll('[data-card-product-link]').forEach((link) => { link.href = variantUrl; });
    if (variantLink) variantLink.href = variantUrl;

  }

  function loadHoverImage(image, priority = 'auto') {
    if (!image) return;

    image.fetchPriority = priority;
    if (!image.dataset.src) return;

    const media = image.closest(mediaSelector);
    const markReady = () => media?.classList.add('is-secondary-ready');

    image.addEventListener('load', markReady, { once: true });
    image.sizes = image.dataset.sizes;
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    delete image.dataset.sizes;
    delete image.dataset.srcset;
    delete image.dataset.src;

    if (image.complete && image.naturalWidth > 0) markReady();
  }

  function playGifOnHover(image) {
    if (!image?.dataset.gifSrc || image.dataset.gifActive === 'true') return;
    image.dataset.gifActive = 'true';
    image.addEventListener('load', () => image.closest('.product-card__media')?.classList.add('is-secondary-ready'), { once: true });
    image.src = image.dataset.gifSrc;
    image.removeAttribute('srcset');
  }

  function stopGifOnHover(image) {
    if (!image?.dataset.gifSrc || image.dataset.gifActive !== 'true') return;
    image.dataset.gifActive = 'false';
    if (image.dataset.gifStaticSrc) {
      image.src = image.dataset.gifStaticSrc;
      return;
    }
    image.removeAttribute('src');
    image.closest('.product-card__media')?.classList.remove('is-secondary-ready');
  }

  function preloadNearbyHoverImages() {
    if (!supportsHover.matches) return;

    const mediaElements = document.querySelectorAll(mediaSelector);
    if (!mediaElements.length) return;

    const schedule = (callback) => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1200 });
      } else {
        window.setTimeout(callback, 200);
      }
    };

    if (!('IntersectionObserver' in window)) {
      schedule(() => {
        mediaElements.forEach((media) => loadHoverImage(media.querySelector('[data-hover-image]'), 'low'));
      });
      return;
    }

    const pendingMedia = new Set();
    let preloadScheduled = false;
    const queuePreload = (media) => {
      pendingMedia.add(media);
      if (preloadScheduled) return;

      preloadScheduled = true;
      schedule(() => {
        pendingMedia.forEach((pendingItem) => {
          loadHoverImage(pendingItem.querySelector('[data-hover-image]'), 'low');
        });
        pendingMedia.clear();
        preloadScheduled = false;
      });
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        queuePreload(entry.target);
      });
    }, { rootMargin: '120px 0px' });

    mediaElements.forEach((media) => observer.observe(media));
  }

  document.addEventListener('pointerover', (event) => {
    if (!supportsHover.matches || !(event.target instanceof Element)) return;

    const media = event.target.closest(mediaSelector);
    const gifMedia = event.target.closest('.product-card__media');
    if (gifMedia) playGifOnHover(gifMedia.querySelector('[data-gif-src]'));
    if (!media) return;

    loadHoverImage(media.querySelector('[data-hover-image]'), 'high');
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (!supportsHover.matches || !(event.target instanceof Element)) return;
    const media = event.target.closest('.product-card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    stopGifOnHover(media.querySelector('[data-gif-src]'));
  }, { passive: true });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const contentOption = event.target.closest('[data-card-content-option]');
    if (contentOption) {
      selectCardVariant(contentOption, '[data-card-content-option]');
      return;
    }

    const colorOption = event.target.closest('[data-card-color-option]');
    if (colorOption) selectCardVariant(colorOption, '[data-card-color-option]');
  });

  if (document.readyState === 'complete') {
    preloadNearbyHoverImages();
  } else {
    window.addEventListener('load', preloadNearbyHoverImages, { once: true });
  }
})();
